import { render, staticRenderFns } from "./CustomerProfileDetails.vue?vue&type=template&id=6153304e"
import script from "./CustomerProfileDetails.vue?vue&type=script&lang=js"
export * from "./CustomerProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports